import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import DashedTooltip from "components/UI/DashedTooltip";
import { returnUpDownClassname } from "utils/helpers";

const EdgeRobustnessCard = (props) => {
  const {
    topWinnersShare,
    clusteredSignalRate,
    maxConsecutiveLosses,
    maxConsecutiveWins,
  } = props.optionsResults.metrics.edgeRobustness;

  return (
    <GenericCard
      title="Edge Robustness"
      tooltipText="Checks on whether the edge above is broad-based and statistically sound, plus the risk-of-ruin concern that still applies to options even though per-trade loss is capped: too many losing premiums paid in a row."
    >
      <div className="pt-2 flex gap-8 flex-wrap">
        <div>
          <DashedTooltip text="Share of total realized gain coming from just the top 3 winning signals. High = the edge rides on a couple of outsized moves rather than being broad-based -- worth double checking those specific signals before trusting the headline success rate.">
            <h5>Top-3 winner concentration</h5>
          </DashedTooltip>
          <h3 className={returnUpDownClassname(-(topWinnersShare - 50))}>
            {topWinnersShare}%
          </h3>
        </div>
        <div>
          <DashedTooltip text="Share of signals firing within 5 calendar days of the previous one. The Wilson interval and significance test above both assume independent observations -- a high clustering rate (e.g. several signals around one earnings week) means the effective sample size is smaller than the raw signal count suggests.">
            <h5>Clustered signals</h5>
          </DashedTooltip>
          <h3 className={returnUpDownClassname(-(clusteredSignalRate - 50))}>
            {clusteredSignalRate}%
          </h3>
        </div>
        <div>
          <DashedTooltip text="Longest run of consecutive losing signals, in chronological order. Even though a single option loss is capped at the premium paid, enough of them back to back is a real risk-of-ruin concern -- what you should be prepared to sit through before the edge shows up again.">
            <h5>Max losing streak</h5>
          </DashedTooltip>
          <h3 className="red">{maxConsecutiveLosses}</h3>
        </div>
        <div>
          <DashedTooltip text="Longest run of consecutive winning signals, in chronological order -- what a good run actually looks like for this combo.">
            <h5>Max winning streak</h5>
          </DashedTooltip>
          <h3 className="green">{maxConsecutiveWins}</h3>
        </div>
      </div>
    </GenericCard>
  );
};

EdgeRobustnessCard.propTypes = { optionsResults: PropTypes.object };

export default EdgeRobustnessCard;
